import { IOpenEntriesGuiModel } from "../model/IOpenEntriesGuiModel";
import OpenEntriesService from "../service/OpenEntriesService";
import { IOpenEntriesModel } from "../service/model/IOpenEntriesModel";
import { BusinessLogicResult } from "./BusinessLogicResult";

export default class OpenEntriesBusinessLogic {

    public async getCustomers(
        organizationId: string,
    ): Promise<BusinessLogicResult<IOpenEntriesGuiModel[]>> {


        const service = new OpenEntriesService();
        const result = await service.getCustomers(organizationId);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IOpenEntriesModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    actorId: e.actorId,
                    actorName: e.actorName ? e.actorName : undefined,
                    actorType: e.actorType,
                    outstanding: e.outstanding,
                    outstandingOverdue: e.outstandingOverdue,
                    openEntries: e.openEntries ? e.openEntries.map(o => {
                        return {
                            invoiceNo: o.invoiceNo ? o.invoiceNo : undefined,
                            voucherId: o.voucherId,
                            voucherDate: new Date(o.voucherDate),
                            voucherType: o.voucherType,
                            standardText: o.standardText ? o.standardText : undefined,
                            amount: o.amount,
                            outstanding: o.outstanding,
                            dueDate: new Date(o.dueDate),
                            remitted: o.remitted,
                            currencyNumber: o.currencyNumber,
                            exchangeRate: o.exchangeRate,
                            amountInCurrency: o.amountInCurrency
                        }
                    }) : [],
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getSuppliers(
        organizationId: string,
    ): Promise<BusinessLogicResult<IOpenEntriesGuiModel[]>> {


        const service = new OpenEntriesService();
        const result = await service.getSuppliers(organizationId);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IOpenEntriesModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    actorId: e.actorId,
                    actorName: e.actorName ? e.actorName : undefined,
                    actorType: e.actorType,
                    outstanding: e.outstanding,
                    outstandingOverdue: e.outstandingOverdue,
                    openEntries: e.openEntries ? e.openEntries.map(o => {
                        return {
                            invoiceNo: o.invoiceNo ? o.invoiceNo : undefined,
                            voucherId: o.voucherId,
                            voucherDate: new Date(o.voucherDate),
                            voucherType: o.voucherType,
                            standardText: o.standardText ? o.standardText : undefined,
                            amount: o.amount,
                            outstanding: o.outstanding,
                            dueDate: new Date(o.dueDate),
                            remitted: o.remitted,
                            currencyNumber: o.currencyNumber,
                            exchangeRate: o.exchangeRate,
                            amountInCurrency: o.amountInCurrency
                        }
                    }) : [],
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getAll(
        organizationId: string,
    ): Promise<BusinessLogicResult<IOpenEntriesGuiModel[]>> {


        const service = new OpenEntriesService();
        const result = await service.getAll(organizationId);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IOpenEntriesModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    actorId: e.actorId,
                    actorName: e.actorName ? e.actorName : undefined,
                    actorType: e.actorType,
                    outstanding: e.outstanding,
                    outstandingOverdue: e.outstandingOverdue,
                    openEntries: e.openEntries ? e.openEntries.map(o => {
                        return {
                            invoiceNo: o.invoiceNo ? o.invoiceNo : undefined,
                            voucherId: o.voucherId,
                            voucherDate: new Date(o.voucherDate),
                            voucherType: o.voucherType,
                            standardText: o.standardText ? o.standardText : undefined,
                            amount: o.amount,
                            outstanding: o.outstanding,
                            dueDate: new Date(o.dueDate),
                            remitted: o.remitted,
                            currencyNumber: o.currencyNumber,
                            exchangeRate: o.exchangeRate,
                            amountInCurrency: o.amountInCurrency
                        }
                    }) : [],
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
}